import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface ConfirmModalProps {
  title?: string | null;
  message?: string | null;
  description?: string | null;
  confirmText?: string | null;
  cancelText?: string | null;
}

export interface ConfirmModalState {
  isOpen: boolean;
  isConfirmed: boolean;
  isDeclined: boolean;
  title: string;
  message: string;
  description: string;
  confirmText: string;
  cancelText: string;
}

const initialState: ConfirmModalState = {
  isOpen: false,
  title: "Are you sure?",
  message: "Click 'Confirm' to continue.",
  description: "Confirm action prompt",
  isConfirmed: false,
  isDeclined: false,
  confirmText: "Confirm",
  cancelText: "Cancel",
};

export const confirmModalSlice = createSlice({
  name: "confirmModal",
  initialState,
  reducers: {
    /** display the given error message */
    open: (state, action: PayloadAction<ConfirmModalProps>) => {
      if (action.payload.title) {
        state.title = action.payload.title;
      }
      if (action.payload.message) {
        state.message = action.payload.message;
      }
      if (action.payload.description) {
        state.description = action.payload.description;
      }
      if ( action.payload.confirmText) {
        state.confirmText =  action.payload.confirmText;
      }
      if (action.payload.cancelText) {
        state.cancelText = action.payload.cancelText;
      }
      state.isOpen = true;
      state.isConfirmed = false;
      state.isDeclined = false;
      
    },
    confirm: (state) => {
      state.isOpen = false;
      state.isConfirmed = true;
      state.isDeclined = false;
    },
    decline: (state) => {
      state.isOpen = false;
      state.isConfirmed = false;
      state.isDeclined = true;
    },
  },
});

export const confirmModalActions = confirmModalSlice.actions;

export const selectConfirmModal = (state: RootState) => state.confirmModal;

export default confirmModalSlice.reducer;
